"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
const switch_style_1 = __importDefault(require("./switch.style"));
class Switch extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hasFocus: false
        };
        this.id = lodash_uniqueid_1.default('cb_');
        this.handleFocus = e => {
            window.clearTimeout(this.timer);
            this.setState({
                hasFocus: true
            });
            this.props.handleFocus(e);
        };
        this.handleBlur = e => {
            window.clearTimeout(this.timer);
            this.timer = window.setTimeout(() => {
                this.setState({
                    hasFocus: false
                });
                this.props.handleBlur(e);
            }, 50);
        };
        this.handleChange = e => {
            if (this.props.disabled)
                return;
            this.props.handleChange(e);
        };
        this.render = () => {
            const { classes, on, inputRef, label, label2, invert, disabled, showLabel } = this.props;
            const { hasFocus } = this.state;
            const rootProps = {
                className: classes.root,
                'data-is-disabled': disabled
            };
            const labelProps = {
                className: classes.label,
                'data-is-on': on,
                'data-is-inverted': invert
            };
            const labelProps2 = {
                className: classes.label2,
                'data-is-on': !on,
                'data-is-inverted': invert
            };
            const switchProps = {
                className: classes.switch,
                'data-is-on': on,
                'data-has-focus': hasFocus
            };
            const inputProps = {
                className: classes.input,
                id: this.id,
                checked: on,
                type: 'checkbox',
                disabled,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onChange: this.handleChange,
                ref: inputRef
            };
            return (jsx_runtime_1.jsxs("label", Object.assign({}, rootProps, { htmlFor: this.id }, { children: [jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: showLabel }, { children: jsx_runtime_1.jsx("div", Object.assign({}, labelProps, { children: label }), void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({}, switchProps, { children: jsx_runtime_1.jsx("input", Object.assign({}, inputProps), void 0) }), void 0),
                    label2 && (jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: showLabel }, { children: jsx_runtime_1.jsx("div", Object.assign({}, labelProps2, { children: label2 }), void 0) }), void 0))] }), void 0));
        };
    }
}
exports.Switch = Switch;
Switch.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.node.isRequired,
    label2: prop_types_1.default.string,
    on: prop_types_1.default.bool,
    handleFocus: prop_types_1.default.func,
    handleBlur: prop_types_1.default.func,
    handleChange: prop_types_1.default.func,
    inputRef: prop_types_1.default.func,
    invert: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    showLabel: prop_types_1.default.bool
};
Switch.defaultProps = {
    label2: '',
    on: false,
    handleFocus: () => { },
    handleBlur: () => { },
    handleChange: () => { },
    inputRef: () => { },
    invert: false,
    disabled: false,
    showLabel: false
};
exports.default = react_jss_1.default(switch_style_1.default)(Switch);
//# sourceMappingURL=switch.js.map